// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.summary.LeaseSummaryWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetLeaseSummaryWebApiResponseDto, LeaseArtifactType } from '../..';

interface GetLeaseSummaryParams {
  leaseArtifactId: number;
  leaseArtifactType: LeaseArtifactType;
}

export const LeaseSummaryWebApiHandler_getLeaseSummary_Path = '/api/web/v1/summary/getLeaseSummary';

/**
 * get lease summary
 */
export const LeaseSummaryWebApiHandler_getLeaseSummary = (getParams: GetLeaseSummaryParams, client = getClient()) => {
  return httpFrontEndRequest<GetLeaseSummaryParams, never, GetLeaseSummaryWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseSummaryWebApiHandler_getLeaseSummary_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
